import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "color", "width", "height", "stroke"];
import React from 'react';
var ErrorIcon = function ErrorIcon(_ref) {
  var className = _ref.className,
    color = _ref.color,
    width = _ref.width,
    height = _ref.height,
    stroke = _ref.stroke,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: width || 'auto',
    height: height || '24',
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: stroke || '#FFF',
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color || '#FFF',
    d: "M12 10.913l2.502-2.501a.84.84 0 0 1 1.188 0l.226.225a.84.84 0 0 1 0 1.189l-2.502 2.502 2.502 2.501a.84.84 0 0 1 0 1.189l-.226.226a.84.84 0 0 1-1.188 0L12 13.742l-2.502 2.502a.84.84 0 0 1-1.188 0l-.226-.226a.84.84 0 0 1 0-1.189l2.502-2.501-2.502-2.502a.84.84 0 0 1 0-1.189l.226-.225a.84.84 0 0 1 1.188 0L12 10.913z"
  })));
};
export default ErrorIcon;